import '../../../../css/toggle.css';
import classnames from 'classnames';

interface Props {
    isOn: boolean;
    onChange: (args: { event: React.ChangeEvent<HTMLInputElement>; isOn: boolean }) => void;
    className?: string;
    testId?: string;
    isDisabled?: boolean;
    id?: string;
    ariaLabel?: string;
}

const Toggle = ({
    isOn,
    onChange,
    className = '',
    testId = '',
    isDisabled = false,
    id = '',
    ariaLabel = '',
}: Props) => {
    const classes = classnames({
        toggle: true,
        [className]: true,
        'is-on': isOn,
        disabled: isDisabled,
    });

    const onToggleChangedClick = (event: React.ChangeEvent<HTMLInputElement>) => {
        if (!isDisabled) {
            onChange({ event, isOn: !isOn });
        }
    };

    const conditionalProps: { id?: string; 'aria-label'?: string } = {};

    if (id !== '') {
        conditionalProps.id = id;
    }

    // Only needed when the toggle has no visible label of its own.
    if (ariaLabel !== '') {
        conditionalProps['aria-label'] = ariaLabel;
    }

    return (
        <input
            {...conditionalProps}
            type="checkbox"
            className={classes}
            data-testid={testId}
            checked={isOn}
            disabled={isDisabled}
            onChange={onToggleChangedClick}
        />
    );
};

export default Toggle;
